import type { Accept } from "react-dropzone";

/** Video formats supported by creator uploads. The extension fallback covers
 * browsers that do not report a MIME type for local QuickTime files. */
export const CREATOR_VIDEO_ACCEPT: Accept = {
  "video/mp4": [".mp4"],
  "video/quicktime": [".mov"],
};

export const isSupportedCreatorVideo = (file: File) =>
  file.type === "video/mp4" ||
  file.type === "video/quicktime" ||
  file.name.toLowerCase().endsWith(".mov") ||
  file.name.toLowerCase().endsWith(".mp4");
